module.exports = __webpack_public_path__ + "media/application/images/2018/icon-top-brand-33b31c904ffa58b3492b90d04f795491.svg";